import React from "react";
import { FaCheck } from "react-icons/fa";
import ClientsCarousel from "./bannerlogo";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const About = () => {
  return (
    <section className="about section-padding">
      {" "}
      {/* Ajout de color: white */}
      <div className="container">
        <div className="row">
          {/* Texte à gauche */}
          <div className="col-md-6 mb-30 animate-box">
            <h2 data-aos="fade-up" className="section-title">
              Bienvenue, je suis <span className="color-blue">Jacob Taieb</span>
              , <span className="color-blue underline-blue">réalisateur</span>{" "}
              et <span className="color-blue underline-blue">photographe</span>{" "}
              basé entre Paris et Marseille.
            </h2>
            <p data-aos="fade-up" data-aos-delay="300">
              Diplômé de l’ESRA Paris, j’ai acquis depuis 2018 une expérience
              solide en publicité, clips musicaux et fiction. Basé entre Paris
              et Marseille, je propose des solutions audiovisuelles complètes
              pour votre entreprise : couverture d’événements, campagnes de
              brand content et portraits professionnels. Mon objectif est
              d’apporter une approche artistique et technique, avec des
              réalisations adaptées à vos besoins pour sublimer votre image..
            </p>
            <ul
              data-aos="fade-up"
              data-aos-delay="600"
              className="list-unstyled about-list mb-30"
            >
              <li>
                <div className="about-list-text">
                  <p> - Des créations sur mesure, adaptées à votre vision </p>
                </div>
              </li>
              <li>
                <div className="about-list-text">
                  <p>
                    - Des années d’expertise illustrées par plus de 100 projets
                    accomplis
                  </p>
                </div>
              </li>
            </ul>
            <hr className="border-2" />
            <div
              data-aos="fade-up"
              data-aos-delay="900"
              className="about-bottom "
            >
              <img
                src="img/signature-dark.svg"
                alt=""
                className="image about-signature img-about"
              />
              <div className="about-name-wrapper">
                <div className="about-name-dark">Jacob Taieb</div>
                <div className="about-rol">Fondateur de Jacob Production</div>
              </div>
            </div>
          </div>

          {/* Image à droite */}
          <div
            className="col-md-5 offset-md-1 animate-box"
            data-animate-effect="fadeInUp"
          >
            <div data-aos="fade-up" className="about-img">
              <div className="img">
                <img src="img/about.jpg" className="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ClientsCarousel />
    </section>
  );
};

export default About;
